module.exports = __webpack_public_path__ + "img/logoAICheckinIntelite-preto.1a33778d.png";